import { useContext } from "react";
import styled from "styled-components";
import { faFilePlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Permission } from "@types";

import { PurpleHeaderContainer } from "@pages/editor/components/EditorHeader/EditorHeader";
import { WorkbenchContext } from "@pages/editor/providers";

import { SplashExamples } from "./SplashExamples";
import { SplashRecents } from "./SplashRecents";
import { IconCard, SplashTutorials } from "./SplashTutorials";

const Header = styled.div`
  font-size: var(--global-font-size-l);
  font-weight: var(--global-font-weight-bold);
`;

const GrayContainer = styled.div`
  padding: 28px;
  padding-top: 24px;
  background-color: var(--light-gray4);
  display: flex;
  flex-flow: row wrap;
  align-items: flex-end;
  gap: 28px;
`;

const CreateRuleCard = styled(IconCard)`
  font-size: var(--global-font-size-l);
`;

const RecentsSection = styled.div`
  flex-grow: 1;
  min-width: 300px;
`;

const SectionHeader = styled.div`
  font-size: var(--global-font-size-m);
  padding-bottom: 8px;
`;

const ExamplesAndTutorialContainer = styled.div`
  padding: 28px;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const AddFileIcon = () => (
  <FontAwesomeIcon
    icon={faFilePlus}
    color="var(--global-file-browser-purple)"
    size="4x"
    fixedWidth
  />
);

export const SplashPanel = () => {
  const { workbench } = useContext(WorkbenchContext);
  return (
    <div style={{ overflowY: "auto" }}>
      <PurpleHeaderContainer
        className="bp3-dark"
        style={{ height: "64px" }} // so the header lines up with the file browser header
      >
        <Header>Editor</Header>
      </PurpleHeaderContainer>
      <GrayContainer>
        {workbench.permissions.includes(Permission.editor_create) && (
          <CreateRuleCard
            interactive
            elevation={1}
            onClick={() => workbench.newBundle()}
          >
            <AddFileIcon />
            <div style={{ paddingTop: "20px", lineHeight: "28px" }}>
              Create New Rule
            </div>
          </CreateRuleCard>
        )}
        <RecentsSection>
          <SectionHeader>Recent</SectionHeader>
          <SplashRecents />
        </RecentsSection>
      </GrayContainer>
      <ExamplesAndTutorialContainer>
        <div>
          <SectionHeader>Examples</SectionHeader>
          <SplashExamples
            style={{ marginLeft: "-10px" }} // shift so text aligns with header
          />
        </div>
        <div>
          <SectionHeader>Learn</SectionHeader>
          <SplashTutorials />
        </div>
      </ExamplesAndTutorialContainer>
    </div>
  );
};
